import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { CollectionService } from '../../../../analytics-settings/services/collection.service';
import { UpperCaseFirstLetterPipe } from '../../../../../shared/utils/pipes/upperCaseFirstLetterPipe';
import { MatTooltip } from '@angular/material/tooltip';
import { MatButton } from '@angular/material/button';
@Component({
    selector: 'app-remove-collection',
    templateUrl: './remove-collection.component.html',
    styleUrls: ['./remove-collection.component.scss'],
    imports: [MatTooltip, MatButton, MatDialogClose, UpperCaseFirstLetterPipe]
})
export class RemoveCollectionComponent implements OnInit {

  collection : any = {};
  savingInProgress: boolean;
  constructor(
    private dialogRef: MatDialogRef<RemoveCollectionComponent>,
    private collectionService: CollectionService,
  ) { }

  ngOnInit(): void {
    this.collection = this.dialogRef._containerInstance._config.data;
  }

  closePopup() {
    this.dialogRef.close();
  }

  deleteCollection() {
    this.dialogRef.close();
    this.collectionService.removeCollectionCard(this.collection);
  }

}
